import Axios from "axios";
import { cloneDeep } from 'lodash';
var PrintConfigService = (function () {
    function PrintConfigService() {
    }
    PrintConfigService.prototype.excludeScene = function (params) {
        var param = cloneDeep(params);
        delete param.scene;
        return param;
    };
    PrintConfigService.prototype.getPrintConfigList = function (params) {
        return Axios.get("supplierclientapi/print/list", { params: params });
    };
    PrintConfigService.prototype.getClientGroups = function (params) {
        return Axios.get("supplierclientapi/customer/group_list", { params: params });
    };
    PrintConfigService.prototype.getPageTypeList = function (params) {
        return Axios.get((params.scene == 'supplier' ? 'synApi/print_template' : 'supplierclientapi/print') + "/get_template_type_list", { params: this.excludeScene(params) });
    };
    PrintConfigService.prototype.getShowTypeList = function (params) {
        return Axios.get((params.scene == 'supplier' ? 'synApi/print_template' : 'supplierclientapi/print') + "/get_show_type", { params: this.excludeScene(params) });
    };
    PrintConfigService.prototype.getPrintTitleItemList = function (params) {
        return Axios.get((params.scene == 'supplier' ? 'synApi/print_template' : 'supplierclientapi/print') + "/get_template_print_title", { params: this.excludeScene(params) });
    };
    PrintConfigService.prototype.getFontSizeList = function (params) {
        return Axios.get((params.scene == 'supplier' ? 'synApi/print_template' : 'supplierclientapi/print') + "/get_font_list", { params: this.excludeScene(params) });
    };
    PrintConfigService.prototype.getCreateTemplateDetail = function (params) {
        return Axios.get((params.scene == 'supplier' ? 'synApi/print_template' : 'supplierclientapi/print') + "/get_create_template_detail", { params: this.excludeScene(params) });
    };
    PrintConfigService.prototype.getDetailTemplateDetail = function (params) {
        return Axios.get("" + (params.scene == 'supplier' ? 'synApi/print_template/detail_template?' : 'supplierclientapi/print/detail'), { params: this.excludeScene(params) });
    };
    PrintConfigService.prototype.addConfig = function (params) {
        return Axios.post("supplierclientapi/print/create", params);
    };
    PrintConfigService.prototype.updConfig = function (params) {
        return Axios.post("" + (params.scene == 'supplier' ? '/synApi/print_template/update' : 'supplierclientapi/print/update'), this.excludeScene(params));
    };
    PrintConfigService.prototype.delConfigs = function (params) {
        return Axios.post("supplierclientapi/print/delete", params);
    };
    PrintConfigService.prototype.getClientsByGroupTree = function (params) {
        return Axios.get("supplierclientapi/customer/group_childs", { params: params });
    };
    PrintConfigService.prototype.applyClients = function (params) {
        return Axios.get("supplierclientapi/print/apply", { params: params });
    };
    PrintConfigService.prototype.copyConfig = function (params) {
        return Axios.get("supplierclientapi/print/copy", { params: params });
    };
    PrintConfigService.prototype.printVerify = function (params) {
        return Axios.get("supplierclientapi/print/verify", { params: params });
    };
    PrintConfigService.prototype.getprintClient = function (params) {
        return Axios.get("supplierclientapi/print/get_business", { params: params });
    };
    PrintConfigService.prototype.getTagSort = function (params) {
        return Axios.get("supplierclientapi/print/get_sort_type", { params: params });
    };
    PrintConfigService.prototype.getTagSortCommon = function (params) {
        return Axios.get((params.scene == 'supplier' ? 'synApi/print_template' : 'supplierclientapi/print') + "/get_sort_type_common", { params: this.excludeScene(params) });
    };
    PrintConfigService.prototype.getSortTagFieldList = function (params) {
        return Axios.get((params.scene == 'supplier' ? 'synApi/print_template' : 'supplierclientapi/print') + "/get_label_field_list", { params: this.excludeScene(params) });
    };
    PrintConfigService.prototype.getSupplierTemplateDetail = function (params) {
        return Axios.get("synApi/print_template/detail", { params: params });
    };
    PrintConfigService.prototype.setPreviewData = function (params) {
        return Axios.post("basicapi/set", params);
    };
    PrintConfigService.createInstance = function () {
        PrintConfigService.getInstance();
    };
    PrintConfigService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return PrintConfigService;
}());
export default PrintConfigService;
